export const unsplash = (id, width = 1200) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${width}&q=85`;

export const handleImageError = (event) => {
  const img = event.currentTarget;

  if (img.dataset.fallbackApplied) return;

  img.dataset.fallbackApplied = 'true';
  img.src = unsplash('photo-1519741497674-611481863552', 1200);
};
